import React from "react";
import "./FooterStyles.css";
import {
  FaFacebook,
  FaMailBulk,
  FaYoutube,
  FaSearchLocation,
  FaInstagram,
} from "react-icons/fa";
import logoBDS from "../../assets/Logo_BDS_Blanc.png";
import logo from "../../assets/logo_toss_blanc.png";

import { Link } from "react-router-dom";


import mazarsLogo from "../../assets/partenaires/logoMazars.png";
import kryole from "../../assets/partenaires/k-ryole.png";
import lydia from "../../assets/partenaires/lydia.png";
import saclay from "../../assets/partenaires/saclay.png";
import polytechnique from "../../assets/partenaires/x.png";
import idf from "../../assets/partenaires/idf.png";
import cs from "../../assets/partenaires/cs.png";
import { useTranslation } from "react-i18next";

import reglementInt from "../../assets/pdf/TOSS_2024_Reglement_interieur.pdf";
import cgiIndiv from "../../assets/pdf/TOSS_2026_CGI_delegs.pdf";
import cgiDeleg from "../../assets/pdf/TOSS_2026_CGI_indiv.pdf";
import Confidialité from "../../assets/pdf/TOSS_2024_Charte_participant.pdf";

const Footer = (props) => {
  const { t } = useTranslation("common");

  return (
    <div className="footer">
      <div className="footer-round" style={{ background: props.color }}></div>
      <div className="footer-animation">
        <div className="footer-animation-2">
          <div>
            <img src={mazarsLogo} className="logo1" alt="Mazars" />
          </div>
          <div>
            <img src={kryole} className="logo2" alt="K-Ryole" />
          </div>
          <div>
            <img src={lydia} className="logo4" alt="Lydia" />
          </div>
          <div>
            <img src={saclay} className="logo8" alt="Paris-Saclay" />
          </div>
          <div>
            <img src={polytechnique} className="logo9" alt="Polytechnique" />
          </div>
          <div>
            <img src={idf} className="logo10" alt="Île-de-France" />
          </div>
          <div>
            <img src={cs} className="logo11" alt="CentraleSupélec" />
          </div>
          <div>
            <img src={mazarsLogo} className="logo1" alt="Mazars" />
          </div>
          <div>
            <img src={kryole} className="logo2" alt="K-Ryole" />
          </div>
          <div>
            <img src={lydia} className="logo4" alt="Lydia" />
          </div>
          <div>
            <img src={saclay} className="logo8" alt="Paris-Saclay" />
          </div>
          <div>
            <img src={polytechnique} className="logo9" alt="Polytechnique" />
          </div>
          <div>
            <img src={idf} className="logo10" alt="Île-de-France" />
          </div>
          <div>
            <img src={cs} className="logo11" alt="CentraleSupélec" />
          </div>
        </div>
      </div>

      <div className="footer-container" style={{ background: props.color }}>
        <div className="first-row">
          <div className="footer-navbar">
            <h4> TOSS 2026</h4>
            <ul>
              <li>
                {" "}
                <Link to="/editorial">Editorial</Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/presentation">Présentation de l'édition</Link>
              </li>
              <li>
                {" "}
                <Link to="/sports">Les sports</Link>
              </li>
              <li>
                {" "}
                <Link to="/galerie">Galerie Photo</Link>
              </li>
            </ul>
          </div>
          <div className="footer-navbar">
            <h4> Partenaires </h4>
            <ul>
              <li>
                <Link to="/mazars">ForvisMazars, partenaire officiel du TOSS</Link>
              </li>
              <li>
                {" "}
                <Link to="/partenaireToss">Partenaires du TOSS</Link>
              </li>
              <li>
                {" "}
                <Link to="/devenirPart">Devenir partenaire</Link>
              </li>
            </ul>
          </div>
          <div className="footer-navbar">
            <h4> Informations pratiques</h4>
            <ul>
              <li>
                {" "}
                <Link to="/tarif">Tarifs de participation</Link>
              </li>
              <li>
                {" "}
                <Link to="/faq">F.A.Q</Link>
              </li>
              <li>
                {" "}
                <Link to="/contacts">Contacts et réclamations</Link>
              </li>
              <li>
                {" "}
                <Link to="/bracelets">Les bracelets Cashless</Link>
              </li>
              <li>
                {" "}
                <Link to="/mentionslegales">Mentions légales</Link>{" "}
              </li>
            </ul>
          </div>
          <div className="footer-navbar">
            <h4> Engagements </h4>
            <ul>
              <li>
                {" "}
                <Link to="/">
                  <img src={logoBDS} width="100" alt="BDS CentraleSupélec" />
                </Link>
              </li>
              <Link to="/engagements">Engagements</Link>
            </ul>
          </div>
          <div className="footer-navbar">
            <h4> Espace participants </h4>
            <ul>
              <li>
                {" "}
                <a href={reglementInt} target="_blank" rel="noopener noreferrer">
                  Règlement intérieur
                </a>{" "}
              </li>
              <li>
                {" "}
                <a href={cgiIndiv} target="_blank" rel="noopener noreferrer">
                  CGI - Délégation
                </a>
              </li>
              <li>
                {" "}
                <a href={cgiDeleg} target="_blank" rel="noopener noreferrer">
                  CGI - Non-Délégation
                </a>
              </li>
              <li>
                {" "}
                <a href={Confidialité} target="_blank" rel="noopener noreferrer">
                  Charte participante
                </a>
              </li>
              <li>
                {" "}
                <a
                  href="https://toss-register.bds-cs.fr/register"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Connexion / Inscription
                </a>{" "}
              </li>
            </ul>
          </div>
        </div>
        <div className="second-row">
          {" "}
          <div className="left">
            <div className="location">
              <FaSearchLocation
                size={20}
                style={{ color: "#ffffff", marginRight: "2rem" }}
              />
              <div>
                <p>3 rue Joliot-Curie </p>
                <h4>Gif-Sur-Yvette, France</h4>
              </div>
            </div>

            <div className="email">
              <h4>
                <FaMailBulk
                  size={20}
                  style={{ color: "#ffffff", marginRight: "2rem" }}
                />{" "}
                <a href="mailto:toss@cs-sports.fr">toss@cs-sports.fr</a>
              </h4>
            </div>
          </div>
          <div className="footer-mazars">
            <a href="https://www.mazarsrecrute.fr/">
              <img src={mazarsLogo} width="300" alt="Mazars" />
            </a>
            <p>{t("footer.description1")}</p>
          </div>
          <div className="right">
            <Link to="/">
              <img src={logo} width="80" alt="TOSS" />
            </Link>

            <div className="social">
              <a href="https://m.facebook.com/toss.cs/posts/">
                {" "}
                <FaFacebook
                  size={30}
                  style={{ color: "#ffffff", marginRight: "1rem" }}
                />
              </a>
              <a href="https://www.instagram.com/toss_cs/?hl=fr">
                {" "}
                <FaInstagram
                  size={30}
                  style={{ color: "#ffffff", marginRight: "1rem" }}
                />
              </a>
              <a href="https://www.youtube.com/channel/UCv7EuHKAclQQN8xyn2Qk0fw">
                {" "}
                <FaYoutube
                  size={30}
                  style={{ color: "#ffffff", marginRight: "1rem" }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright" style={{ background: props.color2 }}>
        <p>
          {" "}
          Copyright 2025-2026 BDS CentraleSupélec - Tous droits réservés. Photos
          par Pics
        </p>
      </div>
    </div>
  );
};

Footer.defaultProps = {
  color: "black",
  color2: "rgba(20,20,20)",
};

export default Footer;

